import script from "./LettureLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./LettureLogs.vue?vue&type=script&setup=true&lang=js"

import "./LettureLogs.vue?vue&type=style&index=0&id=3d462907&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d462907"]])

export default __exports__